import { coachApi } from '@shared/api/client';
import type { FormRecord, SubmissionRecord } from './types';
import {
  adaptFormRecord,
  adaptFormRecordList,
  adaptSubmissionRecord,
  adaptSubmissionRecordList,
} from './adapters';

export const formsApi = {
  listForms: async (siteId: string): Promise<FormRecord[]> => {
    const raw = await coachApi.get<unknown>(`/webbuilder/sites/${siteId}/forms`);
    return adaptFormRecordList(raw);
  },
  createForm: async (
    siteId: string,
    data: { title: string; form_schema_json: Record<string, unknown>; target_host_action?: string }
  ): Promise<FormRecord> => {
    const raw = await coachApi.post<unknown>(`/webbuilder/sites/${siteId}/forms`, data);
    return adaptFormRecord(raw);
  },
  updateForm: async (
    siteId: string,
    formId: string,
    data: { title: string; form_schema_json: Record<string, unknown>; target_host_action?: string }
  ): Promise<FormRecord> => {
    const raw = await coachApi.put<unknown>(`/webbuilder/sites/${siteId}/forms/${formId}`, data);
    return adaptFormRecord(raw);
  },
  listSubmissions: async (formId: string): Promise<SubmissionRecord[]> => {
    const raw = await coachApi.get<unknown>(`/webbuilder/forms/${formId}/submissions`);
    return adaptSubmissionRecordList(raw);
  },
};

export const webbuilderApi = formsApi;
export type * from './types';
